import { initDB } from 'react-indexed-db-hook'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Provider as URQLProvider } from 'urql'
import { Snackbar } from './_features'
import { PasswordForgotPage } from './_features/PasswordForgotPage'
import { PasswordResetPage } from './_features/PasswordResetPage'
import { PublicFestivalPage } from './_features/PublicFestivalPage'
import { PortalEntry } from './_features/PortalEntry'
import { PublicFestivalsPage } from './_features/PublicFestivalsPage'
import { RedirectToApp } from './_features/RedirectToApp'
import { RegistrationPage } from './_features/RegistrationPage'
import { APP_BASE_PATH } from './_lib/festival'
import GraphQLClientSilverstripe from './_lib/graphql/URQLClientSilverstripe'
import { ScanDBConfig } from './_lib/indexDB'
import { AuthenticatedApp } from './AuthenticatedApp'

initDB(ScanDBConfig);

const isAppRoute = window.location.pathname === APP_BASE_PATH
  || window.location.pathname.startsWith(`${APP_BASE_PATH}/`)

const App = () => {
  return (
    <BrowserRouter basename={isAppRoute ? APP_BASE_PATH : undefined}>
      <Snackbar>
        <URQLProvider value={GraphQLClientSilverstripe}>
          {isAppRoute ? (
            <AuthenticatedApp />
          ) : (
            <Routes>
              <Route path={'/login'} element={<PortalEntry />} />
              <Route path={'/festivals'} element={<PublicFestivalsPage />} />
              <Route path={'/festivals/:slug'} element={<PublicFestivalPage />} />
              <Route path={'/passwort-vergessen'} element={<PasswordForgotPage />} />
              <Route path={'/passwort-zuruecksetzen'} element={<PasswordResetPage />} />
              <Route path={'/registrieren'} element={<RegistrationPage />} />
              <Route index element={<PortalEntry />} />
              <Route path={'*'} element={<RedirectToApp />} />
            </Routes>
          )}
        </URQLProvider>
      </Snackbar>
    </BrowserRouter>
  );
}

export default App;
